import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import ReferralRowIcon from 'src/components/Dashboard/components/Referrals/ReferralRowIcon';
import { DynamicTable } from 'common/tables';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import FilterBar from '../FilterBar';
import { programColumn } from '../../utils/columnConfigs/baseColumns';

function getColumns(sortConfig, onSortColumn, showProgramNameColumn) {
  return _.compact([
    {
      label: 'Sending Organization',
      sortColumn: 'referred_by_group.name',
    },
    {
      label: 'Client Name',
      sortColumn: 'contact.full_name',
    },
    {
      label: 'Service Type',
      sortColumn: 'service_type.name',
    },
    showProgramNameColumn ? programColumn('referred_to_program.name', sortConfig, onSortColumn) : null,
    {
      label: 'Date Received',
      type: 'date',
      sortColumn: 'received_at',
      sortBy: sortConfig?.sidx,
      sortDirection: sortConfig.sord,
      setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
    },
    {
      label: 'Last Updated',
      type: 'date',
      sortColumn: 'updated_at',
      sortBy: sortConfig?.sidx,
      sortDirection: sortConfig.sord,
      setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
    },
  ]);
}

const ReferralsIndex = (props) => {
  const {
    paging,
    data,
    onNextClick,
    onPrevClick,
    isFetching,
    onCellClick,
    initialSort,
    filters,
    onFiltersChange,
    fetchGroupsUsers,
    sortConfig,
    setSort,
    showProgramNameColumn,
  } = props;

  const handleSortColumn = (column) => {
    if (setSort) {
      setSort(column);
    }
  };

  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
        dataTestId="referrals-filter-bar"
      />
      <div className="dashboard-inner-content" data-testid="referrals-dashboard-inner-content">
        {(isFetching && _.isEmpty(data)) ?
          <Spinner /> : (
            <DynamicTable
              id="new-referrals-table"
              caption="New referrals"
              dataSet={data}
              onCellClick={onCellClick}
              initialSort={initialSort}
              columnLabels={getColumns(sortConfig, handleSortColumn, showProgramNameColumn)}
              emptyMessage="There are no new referrals."
              rowIcon={(referral) => <ReferralRowIcon referral={referral} />}
            />
        )}
      </div>
    </div>
  );
};

ReferralsIndex.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: shapes.paging,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  initialSort: PropTypes.object,
  filters: PropTypes.array,
  onFiltersChange: PropTypes.func,
  fetchGroupsUsers: PropTypes.func.isRequired,
  setSort: PropTypes.func,
  sortConfig: PropTypes.object,
  showProgramNameColumn: PropTypes.bool,
};

ReferralsIndex.defaultProps = {
  showProgramNameColumn: false,
};

export default ReferralsIndex;
